<template>
  <div ref="printSection" class="print-section">

    <div class="global_theme_ui_page main_task_details_page_wrapper">

      <div class="main_info_wrapper mb-5">
      <div class="info">
        <img
          class="img"
          src="../../assets/new-theme/profile/Image wrap.png"
          alt=""
        />
      </div>
      <div class="info_data">
        <div class="wrap_one">
          <div class="main_user_img_wrapper">
            <img class="user_img" :src="image" alt="user image" />
          </div>
          <div v-if="userData">
            <span class="name d-block"
              >{{ userData.first_name }} {{ userData.last_name }}</span
            >
            <span class="email d-block">{{ userData.email }}</span>
          </div>
        </div>
        <div class="buttons_links">
        </div>
      </div>
    </div>

      <UserPattern :userScore="fixedUserScore"></UserPattern>

      <div v-for="(task, taskIndex) in tasks" :key="task.id"
      :class="['task-start-page', taskIndex === 0 ? 'no-break' : 'force-break']"
      >
        <div class="decode_task_section page-break-avoid">
          <div
            class="d-flex justify-content-between align-items-center mb-3 hide_element_while_printing"
          >
            <h2 class="main_title m-0">{{ localization("Task Decoding") }}</h2>
            <div v-if="task.topic_category !=='default' "
              role="button"
              class="d-flex align-items-center"
              style="gap: 10px"
              @click="ToggleTaskModalForEdit('edit')"
            >
              <img src="@/assets/new-theme/edit-05.png" alt="edit" />
              <span class="primary_theme_color">{{ localization("Edit task description") }}</span>
            </div>
          </div>
          <div class="wrap_decode">
            <div class="wrap_title d-flex align-items-center justify-content-between">
              <div class="part_one">
                <img src="@/assets/new-theme/logo.png" alt="logo" />
                <span class="span_title">{{ localization("Task description") }}</span>
                <span class="span_description">- {{ task.name }}</span>
              </div>
              <div class="d-flex align-items-center hide_element_while_printing" style="gap: 10px">
                <el-switch v-model="switchValue" active-color="#6941c6" inactive-color="#DCDFE6"></el-switch>
                <span>
                  {{ localization("Border style") }}
                </span>

                <span style="color: #212522 ;width: 20px;cursor: pointer" v-tooltip.top-center=" `${localization('Copy with plain text')}` " @click="copyToClipboard(task.desc)">
                  <img src="@/assets/new-theme/icons/copy-icon.svg" alt="" />
                </span>

                <span style="color: #dfdfdfdf ;width: 25px; cursor: pointer" v-tooltip.top-center=" `${localization('Copy with style')}` " @click="copyWithStyleToClipboard(task.description)">
                  <img
                    src="@/assets/new-theme/icons/copy-icon.svg"
                    alt=""
                    class="gradient-border"
                  />
                </span>
              </div>
            </div>

            <div
              ref="taskDescriptionRef"
              class="for-task-description global_decode_content"
              :class="{ border_style: switchValue }"
              v-html="task.description"
            ></div>
          </div>
        </div>
        <div class="global_theme_ui_collapse main_profile_personalize_and_collapse page-break-avoid">
          <el-collapse class="mt-3 customization_for_collapse" v-model="panel" multiple>
            <div
              class="main_child page-break-avoid"
              v-for="(attribute, i) in task.strategy_id"
              :key="i"
              :style="`border : 2px solid ${getProgressColor(i)}`"
            >
              <el-collapse-item :name="`${i}`" class :class="{ break_section: i == 'Precision' }">
                <template #title>
                  <div class="custom_header_of_collapse">
                    <img
                      src="@/assets/new-theme/attributes-images/sequence.png"
                      alt="sequence"
                      v-if="i == 'Sequence'"
                    />
                    <img
                      src="@/assets/new-theme/attributes-images/precision.png"
                      alt="precision"
                      v-if="i == 'Precision'"
                    />
                    <img
                      src="@/assets/new-theme/attributes-images/technical_reasoning.png"
                      alt="technical_reasoning"
                      v-if="i == 'Technical Reasoning'"
                    />
                    <img
                      src="@/assets/new-theme/attributes-images/confluence.png"
                      alt="confluence"
                      v-if="i == 'Confluence'"
                    />
                    <span class="title_word">{{ localization(i)  }} - {{ localization(patternKey(i)) }}</span>
                    <span
                      class="selected_number"
                      v-if="
                        i == 'Sequence' &&
                          task.selected_strategies_count.Sequence
                      "
                    >
                      {{
                      task.selected_strategies_count.Sequence +
                      `${
                      task.selected_strategies_count.Sequence < 2
                      ? localization('strategy selected')
                      : localization('strategies selected')
                      } `
                      }}
                    </span>
                    <span
                      class="selected_number"
                      v-if="
                        i == 'Precision' &&
                          task.selected_strategies_count.Precision
                      "
                    >
                      {{
                      task.selected_strategies_count.Precision +
                      `${
                      task.selected_strategies_count.Precision < 2
                      ? " strategy selected"
                      : " strategies selected"
                      } `
                      }}
                    </span>
                    <span
                      class="selected_number"
                      v-if="
                        i == 'Technical Reasoning' &&
                          task.selected_strategies_count[
                            'Technical Reasoning'
                          ]
                      "
                    >
                      {{
                      task.selected_strategies_count[
                      "Technical Reasoning"
                      ] +
                      `${
                      task.selected_strategies_count[
                      "Technical Reasoning"
                      ] < 2
                      ? " strategy selected"
                      : " strategies selected"
                      } `
                      }}
                    </span>
                    <span
                      class="selected_number"
                      v-if="
                        i == 'Confluence' &&
                          task.selected_strategies_count.Confluence
                      "
                    >
                      {{
                      task.selected_strategies_count.Confluence +
                      `${
                      task.selected_strategies_count.Confluence < 2
                      ? " strategy selected"
                      : " strategies selected"
                      } `
                      }}
                    </span>
                  </div>
                </template>
                <div
                  :style="
                            `color: #fff;border-radius: 8px;padding: 10px ;opacity:0.8;background-color : ${getProgressColor(i)}`
                          "
                  :closable="false"
                  show-icon
                  :class="{ 'text-right': isRtl() }"
                >
                  {{
                    getHint(i, attribute.length > 0, getProgressValue(i), attribute)
                  }}
                </div>
                <div class="p-3">
                  <el-collapse class="collapse_checkboxes">
                    <div class="checkboxes_wrapper page-break-avoid" v-for="(item, index) in attribute" :key="index" >

                      <el-checkbox-group class :value="getSelectedStrategy(task)"  v-if="item">
                        <el-checkbox
                          v-if="item"
                          :label="item.id"
                          :class="{
                            'd-none': item.level1 < 1
                          }"
                        >{{ item.level1 }}</el-checkbox>
                      </el-checkbox-group>
                      <audio controls id="audio" class="d-none">
                        <source id="audio-source" type="audio/mp3" />
                      </audio>
                      <div class="d-flex">

                        <span
                          class="span_img_wrapper hide_element_while_printing"
                          role="button"
                          @click="text_speech_audio(item.level1)"
                        >
                          <img src="@/assets/new-theme/attributes-images/volume.png" alt="volume" />
                        </span>
                        <span class="mx-2" v-if="item.user_id" >
                            <a
                              v-tooltip.top-center=" `${localization('Edit')}` "
                              class="btn btn-warning btn-simple btn-link"
                              @click="edit_strategy_dialog(item)"
                            >
                              <img
                                src="@/assets/new-theme/edit.png"
                                alt="edit-05-inactive"
                              />
                            </a>
                        </span>
                      </div>
                    </div>
                    <div
                      class="your_own_statement hide_element_while_printing"
                      @click="open_strategy_dialog(i)"
                    >
                      <img role="button" src="@/assets/new-theme/profile/plus.png" alt="plus" />
                      <span role="button">{{ localization("Add your own personalized statement") }}</span>
                    </div>
                  </el-collapse>
                </div>
              </el-collapse-item>
            </div>
          </el-collapse>
        </div>
        <div v-if="taskIndex < tasks.length - 1" class="page-break-after task-separator"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";

export default {
  name: "TaskDetails",
  data() {
    return {
      showHideModalShare: false,
      fixedUserScore: null,
      emailForm: {
        email: "",
        subject: "",
        message: ""
      },
      emailRules: {
        email: [
          {
            required: true,
            message: this.localization("Please enter an email address"),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.localization("Please enter a valid email address"),
            trigger: "blur"
          }
        ]
      },
      editing_item:false,
      sharingPdf: false,
      panel: [`Precision`, `Sequence`, "Technical Reasoning", "Confluence"],
      selected: [],
      taskStrategies: [],
      fileList: [],
      strategy_Dialog: false,
      strategy: {},
      type: "",
      mainTask: {},
      showAddTask: false,
      taskDialogVisible: false,
      loading: false,
      switchValue: false,
      task: {
        name: "",
        topic_id: "",
        description: ""
      },
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: this.localization("Please enter the task name"),
            trigger: "blur"
          }
        ],
        topic_id: [
          {
            required: true,
            message: this.localization("Please enter the task topic"),
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: this.localization("Please enter a task description"),
            trigger: "blur"
          }
        ]
      },
      showHideModalUserType: false
    };
  },
  computed: {
    mainUserId() {
      return this.auth().id;
    },
    image() {
      if (this.userData.image) {
        return `${process.env.VUE_APP_BASE_URL}/users/photo/${this.userData.image}`;
      }
      return "/static/img/lml-swerl.jpg";
    },
    userScore() {
      return this.$store.getters["user/score"];
    },
    userAttributes() {
      return this.taskStrategies;
    },
    mainTaskData() {
      return this.mainTask;
    },
    isAuthEqualUser() {
      return this.auth().id == this.mainUserId;
    },
    userData() {
      return this.$store.state.user.user;
    },
    userStrategyBoxes() {
      return this.$store.getters["user/get_user_strategy_boxes"];
    },
    taskId() {
      return this.$route.params.task_id;
    },
    standardTopicsData() {
      return this.$store.getters["topics/getStandardTopics"];
    },
    user_id() {
      return this.$route.query.user_id
        ? this.$route.query.user_id
        : this.auth().id;
    }
  },
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    selectedTasks: {
      type :Array,
      default: ()=> []
    },
    topics: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getSelectedStrategy(task){
      return task.selected_strategy_id || [];
    },
    getMainUserData() {
      this.$store.dispatch("user/user", this.$route.query.user_id ? this.$route.query.user_id : this.auth().id).then(() => {
        this.$store.dispatch("topics/handlerStandardTopics");
        if (this.userData.sequence) {
        } else {
          this.$router.push("/new-theme/instructions");
        }
      });
    },

    edit_strategy_dialog(item) {
      this.editing_item = item;
      this.strategy = { ...item };
      this.strategy_Dialog = true;
    },
    open_strategy_dialog(pattern) {
      this.strategy.pattern = pattern;
      this.strategy_Dialog = true;
    },
    submit_custom(){
      this.editing_item ? this.edit_custom() : this.add_custom();
    },
    edit_custom() {
      this.$refs["addStrategyForm"].validate(valid => {
        if (valid) {
          this.$store
            .dispatch("strategies/UpdateStrategies", {
              id: this.strategy.id,
              query: this.strategy
            })
            .then(_ => {
              this.strategy_Dialog = false;
              this.editing_item = false;
              this.strategy.level1 = "";
              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success ",
                buttonsStyling: false
              });
              this.refresh();
            });
        } else {
          return false;
        }
      });
    },
    add_custom() {
      this.$refs["addStrategyForm"].validate(valid => {
        if (valid) {
          this.$store
            .dispatch("strategies/addCustom", {
              id: this.taskId,
              query: this.strategy
            })
            .then(_ => {
              this.strategy_Dialog = false;
              this.strategy.level1 = "";
              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success ",
                buttonsStyling: false
              });
              this.refresh();
            });
        } else {
          return false;
        }
      });
    },
// printPlp() {
//   this.applyPrintStyles();
//   this.prepareContentForPrint();

//   const printEl = this.$refs.printSection;
//   if (printEl) {
//     const isEdge = navigator.userAgent.includes('Edg');
//     const timeout = isEdge ? 1500 : 800;

//     setTimeout(() => {
//       // Re-check and adjust content after styles are applied
//       this.$nextTick(() => {
//         this.forcePageBreakProtection();

//         const options = {
//           margin: 0.5,
//           filename: 'tasks.pdf',
//           html2canvas: {
//             scale: isEdge ? 2 : 2, // Reduced scale for better reliability
//             useCORS: true,
//             allowTaint: !isEdge,
//             scrollX: 0,
//             scrollY: 0,
//             logging: false
//           },
//           jsPDF: {
//             unit: 'in',
//             format: 'letter',
//             orientation: 'portrait'
//           },
//           pagebreak: {
//             mode: ['avoid-all', 'css', 'legacy'],
//             before: '.force-page-break-before',
//             after: '.force-page-break-after',
//             avoid: ['.main_child', '.task-section', '.decode_task_section']
//           }
//         };

//         html2pdf()
//           .set(options)
//           .from(printEl)
//           .save()
//           .then(() => {
//             setTimeout(() => {
//               window.close();
//             }, 1000);
//           })
//           .catch(error => {
//             console.error('Print error:', error);
//             // Fallback: try without html2pdf
//             this.fallbackPrint();
//           });
//       });
//     }, timeout);
//   }
// },
printPlp() {
  window.print();
},
prepareContentForPrint() {
  // Add protective wrappers around each bordered section
  const mainChildren = document.querySelectorAll('.main_child');
  mainChildren.forEach((child, index) => {
    // Add protective classes and attributes
    child.classList.add('print-protected-section');
    child.setAttribute('data-section-index', index);

    // Ensure each section has minimum content height
    const content = child.querySelector('.el-collapse-item__content');
    if (content) {
      const computedStyle = window.getComputedStyle(content);
      const minHeight = Math.max(content.scrollHeight, 200); // At least 200px
      content.style.minHeight = `${minHeight}px`;
    }
  });
},

forcePageBreakProtection() {
  // More aggressive approach: manually check and force page breaks
  const sections = document.querySelectorAll('.main_child');
  let currentPageHeight = 0;
  const estimatedPageHeight = 1000; // Approximate pixels per page

  sections.forEach((section, index) => {
    const sectionHeight = section.offsetHeight;

    // If adding this section would exceed page height, force page break
    if (currentPageHeight + sectionHeight > estimatedPageHeight * 0.9) {
      const pageBreakDiv = document.createElement('div');
      pageBreakDiv.className = 'force-page-break-before';
      pageBreakDiv.style.pageBreakBefore = 'always';
      pageBreakDiv.style.breakBefore = 'page';
      pageBreakDiv.style.height = '0';
      pageBreakDiv.style.margin = '0';
      pageBreakDiv.style.padding = '0';

      section.parentNode.insertBefore(pageBreakDiv, section);
      currentPageHeight = sectionHeight;
    } else {
      currentPageHeight += sectionHeight;
    }

    // Add protective spacing
    section.style.marginBottom = '30px';
    section.style.paddingBottom = '15px';
  });
},

fallbackPrint() {
  // Simple window.print fallback
  const printStyles = `
    <style>
      @media print {
        body * {
          visibility: hidden;
        }
        .print-section, .print-section * {
          visibility: visible;
        }
        .print-section {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        .main_child {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin-bottom: 50px !important;
          border: 2px solid !important;
        }
        .hide_element_while_printing {
          display: none !important;
        }
      }
    </style>
  `;

  document.head.insertAdjacentHTML('beforeend', printStyles);
  window.print();
},

applyPrintStyles() {
  const style = document.createElement('style');
  style.innerHTML = `
    @media print {
      /* Nuclear option: force everything to avoid breaks */
      .print-protected-section,
      .main_child,
      .task-section,
      .decode_task_section,
      .global_theme_ui_collapse,
      .el-collapse-item,
      .el-collapse-item__wrap,
      .el-collapse-item__content,
      .wrap_decode {
        page-break-inside: avoid !important;
        break-inside: avoid-page !important;
        -webkit-column-break-inside: avoid !important;
        display: block !important;
        overflow: visible !important;
      }

      /* Force sections to be treated as block elements */
      .main_child {
        display: block !important;
        float: none !important;
        position: relative !important;
        margin-bottom: 40px !important;
        padding-bottom: 20px !important;
        min-height: 200px !important;
        border: 2px solid !important;
        box-decoration-break: slice !important;
        -webkit-box-decoration-break: slice !important;
      }

      /* Manual page break control */
      .force-page-break-before {
        page-break-before: always !important;
        break-before: page !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .force-page-break-after {
        page-break-after: always !important;
        break-after: page !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      /* Remove any potential splitting elements */
      .el-collapse-item__header {
        border-bottom: none !important;
      }

      /* Ensure content doesn't get cut */
      .el-collapse-item__content {
        padding-bottom: 25px !important;
        min-height: 150px !important;
      }

      /* Hide everything non-essential */
      .hide_element_while_printing {
        display: none !important;
      }

      /* Reset body margins */
      body {
        margin: 0 !important;
        padding: 10px !important;
      }

      /* Global print reset */
      * {
        box-sizing: border-box !important;
      }
    }

    /* Pre-print preparation */
    .print-protected-section {
      border: 2px solid transparent;
      margin-bottom: 20px;
      page-break-inside: avoid;
    }
  `;
  document.head.appendChild(style);
},

    // Toggle Modal User Type
    toggleModalShare() {
      this.showHideModalShare = !this.showHideModalShare;
    },
    submitShared(sharedEmails) {
      let payload = {
        id: this.taskId,
        emails: sharedEmails
      };

      this.$store.dispatch("user/share_school_task", payload).then(() => {
        this.showHideModalShare = !this.showHideModalShare;
        Swal.fire({
          title: "",
          text: `${this.localization("Done")}`,
          confirmButtonText: `${this.localization("Ok")}`,
          icon: "success",
          confirmButtonClass: "btn btn-success",
          buttonsStyling: false
        });
      });
    },
    getProgressValue(key) {
      switch (key) {
        case "Precision":
          return this.userScore.precision;
        case "Technical Reasoning":
          return this.userScore.technical_reasoning;
        case "Confluence":
          return this.userScore.confluence;
        case "Sequence":
          return this.userScore.sequence;
      }
    },
    getHint(key, decode, score, item) {
      var type = false;

      if (score >= 7 && score < 18) {
        type = "Forge";
      } else if (score >= 18 && score < 25) {
        type = "Intensify";
      }
      if (decode) {
        type = item[0] ? item[0].classification : type;
        if (type == "Use First") {
          if (key == "Sequence") {
            return `${this.localization("Hey, you have enough Sequence to complete this task, but you might want to check out these strategies to keep your Sequence from taking over.")}`;
          } else if (key == "Precision") {
            return `${this.localization("Hey, you have enough Precision to complete this task, but you might want to check out these strategies to keep your Precision from taking over.")}`;
          } else if (key == "Technical Reasoning") {
            return `${this.localization("Hey, you have enough Technical Reasoning to complete this task, but you might want to check out these strategies to keep your Technical Reasoning from taking over.")}`;
          } else if (key == "Confluence") {
            return `${this.localization("Hey, you have enough Confluence to complete this task, but you might want to check out these strategies to keep your Confluence from taking over.")}`;
          }
        } else if (type) {
          // Intensify
          if (type == "Intensify" && key == "Sequence") {
            return `${this.localization("To complete this task, you need to INTENSIFY your Sequence. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (type == "Intensify" && key == "Precision") {
            return `${this.localization("To complete this task, you need to INTENSIFY your Precision. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (type == "Intensify" && key == "Technical Reasoning") {
            return `${this.localization("To complete this task, you need to INTENSIFY your Technical Reasoning. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (type == "Intensify" && key == "Confluence") {
            return `${this.localization("To complete this task, you need to INTENSIFY your Confluence. Please choose as many sentences below that would help you complete your task.")}`;
          }
          if (type == "Forge" && key == "Sequence") {
            return `${this.localization("To complete this task, you need to FORGE your Sequence. Please choose as many strategies below that would help you complete your task.")}`;
          } else if (type == "Forge" && key == "Precision") {
            return `${this.localization("To complete this task, you need to FORGE your Precision. Please choose as many strategies below that would help you complete your Personal Strategies.")}`;
          } else if (type == "Forge" && key == "Technical Reasoning") {
            return `${this.localization("To complete this task, you need to FORGE your Technical Reasoning. Please choose as many strategies below that would help you complete your Personal Strategies.")}`;
          } else if (type == "Forge" && key == "Confluence") {
            return `${this.localization("To complete this task, you need to FORGE your Confluence. Please choose as many strategies below that would help you complete your Personal Strategies.")}`;
          }
          // tether
          if (type == "Tether" && key == "Sequence") {
            return `${this.localization("To complete this task, you have to TETHER your Sequence. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (type == "Tether" && key == "Precision") {
            return `${this.localization("To complete this task, you have to TETHER your Precision. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (type == "Tether" && key == "Technical Reasoning") {
            return `${this.localization("To complete this task, you have to TETHER your Technical Reasoning. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (type == "Tether" && key == "Confluence") {
            return `${this.localization("To complete this task, you have to TETHER your Confluence. Please choose as many sentences below that would help you complete your task.")}`;
          }
        } else {
          //// if pattern exist and score between 25 &b 35
          if (key == "Sequence") {
            return `${this.localization("Hey, you have enough Sequence to complete this task, but you might want to check out these strategies to keep your Sequence from taking over.")}`;
          } else if (key == "Precision") {
            return `${this.localization("Hey, you have enough Precision to complete this task, but you might want to check out these strategies to keep your Precision from taking over.")}`;
          } else if (key == "Technical Reasoning") {
            return `${this.localization("Hey, you have enough Technical Reasoning to complete this task, but you might want to check out these strategies to keep your Technical Reasoning from taking over.")}`;
          } else if (key == "Confluence") {
            return `${this.localization("Hey, you have enough Confluence to complete this task, but you might want to check out these strategies to keep your Confluence from taking over.")}`;
          }
        }
      } else {
        // If no pattern //// and score between 7-18 -- type now FORGE
        if (type && type == "Forge") {
          if (key == "Sequence") {
            return `${this.localization("Congratulations! Since there is no Sequence required in this task and you avoid Sequence, no strategies are needed.")}`;
          } else if (key == "Precision") {
            return `${this.localization("Congratulations! Since there is no Precision required in this task and you avoid Precision, no strategies are needed.")}`;
          } else if (key == "Technical Reasoning") {
            return `${this.localization("Congratulations! Since there is no Technical Reasoning required in this task and you avoid Technical Reasoning, no strategies are needed.")}`;
          } else if (key == "Confluence") {
            return `${this.localization("Congratulations! Since there is no Confluence required in this task and you avoid Confluence, no strategies are needed.")}`;
          }
        } else if (type && type == "Intensify") {
          if (key == "Sequence") {
            return `${this.localization("To complete this task, you need to INTENSIFY your Sequence. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (key == "Precision") {
            return `${this.localization("To complete this task, you need to INTENSIFY your Precision. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (key == "Technical Reasoning") {
            return `${this.localization("To complete this task, you need to INTENSIFY your Technical Reasoning. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (key == "Confluence") {
            return `${this.localization("To complete this task, you need to INTENSIFY your Confluence. Please choose as many sentences below that would help you complete your task.")}`;
          }
        } else {
          if (key == "Sequence") {
            return `${this.localization("To complete this task, you have to TETHER your Sequence. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (key == "Precision") {
            return `${this.localization("To complete this task, you have to TETHER your Precision. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (key == "Technical Reasoning") {
            return `${this.localization("To complete this task, you have to TETHER your Technical Reasoning. Please choose as many sentences below that would help you complete your task.")}`;
          } else if (key == "Confluence") {
            return `${this.localization("To complete this task, you have to TETHER your Confluence. Please choose as many sentences below that would help you complete your task.")}`;
          }
        }
      }
    },
    getProgressColor(key) {
      switch (key) {
        case "Precision":
          return "#3c3";
        case "Technical Reasoning":
          return "#f93";
        case "Confluence":
          return "#c36";
        case "Sequence":
          return "#39c";
      }
    },
    // Return pattern key in collapse
    patternKey(name) {
      if (name == "Sequence") {
        // Start Pattern range
        if (this.userScore?.sequence >= 25 && this.userScore.sequence <= 35) {
          return "Use First";
        } else if (
          this.userScore?.sequence >= 7 &&
          this.userScore.sequence <= 17
        ) {
          return "Avoid";
        } else if (
          this.userScore?.sequence >= 18 &&
          this.userScore.sequence <= 24
        ) {
          return "As Needed";
        }
        // End Pattern range
      }
      if (name == "Precision") {
        // Start Pattern range
        if (this.userScore?.precision >= 25 && this.userScore.precision <= 35) {
          return "Use First";
        } else if (
          this.userScore?.precision >= 7 &&
          this.userScore.precision <= 17
        ) {
          return "Avoid";
        } else if (
          this.userScore?.precision >= 18 &&
          this.userScore.precision <= 24
        ) {
          return "As Needed";
        }
        // End Pattern range
      }
      if (name == "Technical Reasoning") {
        // Start Pattern range
        if (
          this.userScore?.technical_reasoning >= 25 &&
          this.userScore.technical_reasoning <= 35
        ) {
          return "Use First";
        } else if (
          this.userScore?.technical_reasoning >= 7 &&
          this.userScore.technical_reasoning <= 17
        ) {
          return "Avoid";
        } else if (
          this.userScore?.technical_reasoning >= 18 &&
          this.userScore.technical_reasoning <= 24
        ) {
          return "As Needed";
        }
        // End Pattern range
      }
      if (name == "Confluence") {
        // Start Pattern range
        if (
          this.userScore?.confluence >= 25 &&
          this.userScore.confluence <= 35
        ) {
          return "Use First";
        } else if (
          this.userScore?.confluence >= 7 &&
          this.userScore.confluence <= 17
        ) {
          return "Avoid";
        } else if (
          this.userScore?.confluence >= 18 &&
          this.userScore.confluence <= 24
        ) {
          return "As Needed";
        }
        // End Pattern range
      }
    },
    // Get task details
    getTaskDetails() {
      const taskIds = this.selectedTasks;
      console.log('Fetching details for:', taskIds);
      this.$store.dispatch('user/show_tasks', {selected_tasks: taskIds})
        .then((res) => {
          this.tasks = res.tasks
          this.$nextTick(() => {
            setTimeout(() => {
              this.printPlp();
            }, 1000);   // small delay for images, collapse, etc.
          });
        });

      let html_task_handler = document.querySelector(".for-task-description");
      const all_child_nodes = Array.from(
        html_task_handler.getElementsByTagName("div")
      );
      all_child_nodes.forEach(element => {
        let get_tooltip_data = element.getAttribute("data-tooltip");
        let create_span = document.createElement("span");
        create_span.textContent = get_tooltip_data;
        create_span.setAttribute("class", "span_for_tooltips");
        element.appendChild(create_span);
      });
    },
    stripHtml(html) {
      if (!html) return "";
      return html.replace(/<[^>]*>/g, ""); // Remove all HTML tags
    },


    text_speech_audio(any_text) {
      this.$store
        .dispatch("user/get_text_to_speech_audio", { text: any_text })
        .then(res => {
          let audioBlob = new Blob([res], { type: "audio/mpeg" });
          let audioURL = URL.createObjectURL(audioBlob);
          let audio = document.getElementById("audio");
          var source = document.getElementById("audio-source");
          source.src = audioURL;
          audio.load();
          audio.play();
        });
    },
    // Edit Task
    ToggleTaskModalForEdit(type) {
      this.type = type;
      this.task.name = this.mainTask.name;
      this.task.description = this.stripHtml(this.mainTask.description);
      this.task.topic_id = this.mainTask.topic_id;
      this.dialogVisible = !this.dialogVisible;
    },
    handleUploadSuccess(file, fileList) {
      this.fileList = fileList;
      this.handle_upload_file_img(file);
    },
    resetTaskForm() {
      this.taskDialogVisible = false;
    },
    resetForm() {
      this.$refs.taskForm.resetFields();
      this.dialogVisible = false;
      // this.$v.$reset();
    },
    ToggleTaskModal(type) {
      if (type == 'add'){
        this.task = {
          name: "",
          topic_id: "",
          description: ""
        }
      }
      this.showAddTask = !this.showAddTask;
      this.taskDialogVisible = !this.taskDialogVisible;
      this.type = type;
    },
    handle_upload_file_img(file) {
      this.loading = true;
      this.description_photo = file.raw;
      let payload = new FormData();
      payload.append("photo", file.raw);
      this.$store
        .dispatch("user/get_ocr_photo_description", payload)
        .then(response => {
          this.task.description = response.photo_description;
          this.loading = false;
          Swal.fire({
            title: "",
            icon: "success",
            text: `${this.localization("Please double check the extracted text!")}`,
            type: "success",
            confirmButtonText: `${this.localization("Ok")}`,
            confirmButtonClass: "btn btn-success ",
            buttonsStyling: false
          });
        });
      this.fileList = [];
      this.loading = false;
    },
    submitForm() {
      this.$refs.taskForm.validate(valid => {
        if (valid) {
          if (this.type == "add") {
            this.$store
              .dispatch("user/add_task", {
                query: this.task
              })
              .then(response => {
                this.dialogVisible = false;

                Swal.fire({
                  title: "",
                  icon: "success",
                  text: `${this.localization("Done")}`,
                  confirmButtonText: `${this.localization("Ok")}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success ",
                  buttonsStyling: false
                });
                this.$router.push(`/new-theme/tasks/${response.task.id}`);
                this.refresh({});
                this.taskDialogVisible = !this.taskDialogVisible;
              })
              .catch(_ => {
                this.dialogVisible = false;
              });
          } else {
            this.$store
              .dispatch("user/edit_task", {
                query: this.task,
                id: this.taskId
              })
              .then(_ => {
                this.dialogVisible = false;

                Swal.fire({
                  title: "",
                  icon: "success",
                  text: `${this.localization("Done")}`,
                  confirmButtonText: `${this.localization("Ok")}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success ",
                  buttonsStyling: false
                });
                this.refresh({});
              })
              .catch(_ => {
                this.dialogVisible = false;
              });
          }
        } else {
          return false;
        }
      });
    },
    // submitForm() {
    //   this.$refs.taskForm.validate(valid => {
    //     if (valid) {
    //       this.$store
    //         .dispatch("user/edit_task", {
    //           query: this.task,
    //           id: this.taskId
    //         })
    //         .then(_ => {
    //           this.dialogVisible = false;

    //           Swal.fire({
    //             title: "",
    //             icon: "success",
    //             text: `${this.localization("Done")}`,
    //             confirmButtonText: `${this.localization("Ok")}`,
    //             type: "success",
    //             confirmButtonClass: "btn btn-success ",
    //             buttonsStyling: false
    //           });
    //           this.taskDialogVisible = false;
    //           this.refresh({});
    //           window.scrollTo({ top: 0, behavior: "smooth" });
    //         })
    //         .catch(_ => {
    //           this.dialogVisible = false;
    //           this.taskDialogVisible = false;
    //         });
    //     }
    //   });
    // },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("File size cannot exceed 5MB.");
      }
      return isLt5M;
    },
    deleteTask() {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "error",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(date => {
        if (date.isConfirmed) {
          let payload = {
            tasks: [this.$route.params.task_id]
          };
          this.$store.dispatch("tasks/handleDeleteTasks", payload).then(_ => {
            this.$router.push("/new-theme/tasks");
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Deleted")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          });
        }
      });
    },
    copyWithStyleToClipboard() {
      const element = this.$refs.taskDescriptionRef;

      if (!element) {
        console.error('Element not found');
        return;
      }

      // Get the text to understand the word spacing
      const originalText = element.textContent || element.innerText || '';


      // Simple approach: replace classes with styles and clean up
      let simpleHtml = element.innerHTML;

      // First replace <br> tags with spaces
      simpleHtml = simpleHtml.replace(/<br\s*\/?>/gi, ' ');

      // Then replace the classes with styled spans
      simpleHtml = simpleHtml
        .replace(/<div class="sequence"/g, '<span style="color: #3399cc; font-weight: bold; text-decoration: underline; display: inline;"')
        .replace(/<div class="precision"/g, '<span style="color: #33cc33; font-weight: bold; text-decoration: underline; display: inline;"')
        .replace(/<div class="technical_reasoning"/g, '<span style="color: #ff9933; font-weight: bold; text-decoration: underline; display: inline;"')
        .replace(/<div class="confluence"/g, '<span style="color: #cc3366; font-weight: bold; text-decoration: underline; display: inline;"')
        .replace(/<\/div>/g, '</span>');

      // Normalize spaces but preserve word boundaries
      simpleHtml = simpleHtml
        .replace(/\s+/g, ' ')
        .replace(/>\s+</g, '> <') // Preserve space between elements
        .trim();

      const fullHtml = `
        <div style="font-family: Arial, sans-serif; line-height: 1.4;">
          ${simpleHtml}
        </div>
      `;

      const plainText = originalText.replace(/\s+/g, ' ').trim();

      const clipboardItem = new ClipboardItem({
        'text/html': new Blob([fullHtml], { type: 'text/html' }),
        'text/plain': new Blob([plainText], { type: 'text/plain' })
      });

      navigator.clipboard.write([clipboardItem]).then(() => {
        this.$message({
          message: this.localization('Content copied to clipboard with styles!'),
          type: 'success',
        });
      }).catch(err => {
        console.error('Failed to copy styled content: ', err);
        // this.fallbackCopyTextToClipboard(plainText);
      });
    },
    loadUserScore() {
      return this.$store.dispatch("user/user", this.user_id)
        .then(() => {
          const user = this.$store.state.user.user;

          // take a snapshot
          this.fixedUserScore = {
            sequence: user.sequence,
            precision: user.precision,
            technical_reasoning: user.technical_reasoning,
            confluence: user.confluence,
          };

          console.log("Loaded Score For User:", this.user_id, this.fixedUserScore);
        });
    },
    getTaskDetails() {
      const taskIds = this.selectedTasks;
      this.$store
        .dispatch("user/show_tasks", { selected_tasks: taskIds })
        .then((res) => {
          this.tasks = res.tasks;

          /*this.$nextTick(() => {
            setTimeout(() => {
              this.printPlp();
            }, 900);
          });*/
          this.waitForFullLoad().then(() => {
            setTimeout(() => {
              window.print();
            }, 1000);
          });

        });
    },
    waitForFullLoad() {
      return new Promise(resolve => {
        // (1) Wait for Vue DOM rendering
        this.$nextTick(() => {
          // (2) Wait for all images to load
          const imgs = Array.from(document.images);
          let loaded = 0;

          if (imgs.length === 0) return resolve();

          imgs.forEach(img => {
            if (img.complete) {
              loaded++;
              if (loaded === imgs.length) resolve();
            } else {
              img.addEventListener("load", () => {
                loaded++;
                if (loaded === imgs.length) resolve();
              });
              img.addEventListener("error", () => {
                loaded++;
                if (loaded === imgs.length) resolve();
              });
            }
          });
        });
      });
    }

  },
  mounted() {
    this.loadUserScore()
      .then(() => {
        this.getTaskDetails();
      });

    this.$store.dispatch("user/handlerUserStrategyBoxes");
  }
};
</script>

<style lang="scss" scoped>
/* Print-specific styles */
.main_task_details_page_wrapper {
  // Use Your Learning Patterns
  .learner_patterns_wrapper {
    margin-top: 40px;
    .titles_wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .print_share_buttons {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }

    .text {
      color: #667085;
      font-weight: 400;
      font-size: 16px;
    }
    .main_cards {
      display: flex;
      justify-content: space-between;
      gap: 4%;
      .card_item {
        border-radius: 8px;
        border: 1px solid #eaecf0;
        padding: 24px;
        width: calc(96% / 3);

        .title {
          color: #101828;
          font-weight: 600;
          font-size: 18px;
        }
        .description {
          color: #667085;
          font-weight: 400;
          font-size: 16px;
        }
        .lci_btn {
          background-color: #f2f4f7;
          color: #6941c6;
          border-radius: 8px;
          padding: 12px 20px;
          border: 1px solid #eaecf0;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          font-weight: 500;
          font-size: 16px;
        }
      }
    }
  }

  .main_title {
    color: #101828;
    font-weight: 600;
    font-size: 20px;
    &.white_text {
      color: #fff;
    }
  }
  .text {
    color: #667085;
    font-weight: 400;
    font-size: 16px;
  }
  .your_personal_wrapper {
    border-radius: 8px;
    border: 1px solid #eaecf0;
    padding: 24px;
    &.margin_bottom {
      margin-bottom: 24px;
    }
    .print_share_buttons {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-top: 20px;
      .btn_2 {
        border: 1px solid transparent;
        border-radius: 8px;
        color: #6941c6;
        font-size: 14px;
        height: 41px;
        padding: 10px 16px;
        display: flex;
        align-items: center;
        font-weight: 500;
        gap: 10px;
        background: #fff;
        flex-grow: 1;
        justify-content: center;
        &.share {
          background-color: #f9f5ff;
        }
        &.print {
          border-color: #6941c6;
        }
      }
    }
  }
  .delete_section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .delete_btn {
      border: none;
      background: none;
      color: #b42318;
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>

<style lang="scss">
.user_modal {
  padding: 0;
  .el-dialog__header {
    display: none !important;
  }
}

.main_profile_personalize_and_collapse {
  .el-collapse {
    border: none !important;
  }
  .el-collapse-item__content {
    box-shadow: none !important;
    border: none !important;
  }
  .el-collapse-item__wrap {
    border-bottom: none !important;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
    font-size: 16px;
    line-height: inherit;
    color: #344054 !important;
  }
  .el-checkbox__inner {
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    height: 20px;
    width: 20px;
  }
  .el-checkbox {
    align-items: flex-start;
    display: flex;
  }
  .el-checkbox__label,
  .el-checkbox is-checked {
    color: #344054 !important;
    font-weight: 400;
    font-size: 16px;

    // max-width: 98%;
    word-break: break-word !important;
    white-space: pre-wrap;
    // word-wrap: break-word;
    white-space: normal;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #6941c6;
    border-color: #6941c6;
  }
  .el-checkbox__inner::after {
    left: 7px;
    top: 4px;
    border-width: 2px;
  }
}
::v-deep .input_with_custom_text_area .el-textarea__inner {
  word-break: break-word !important; /* Ensures long words break */
  overflow-wrap: break-word !important; /* Ensures text wraps properly */
  white-space: pre-wrap !important; /* Preserves line breaks */
}
.task_card{
  background-color: #7f56d9;
  color: #fff;
  min-height: 150px;
  padding: 20px;
  border-radius: 15px;
}
.gradient-border {
  border: 2px solid transparent;
  border-image: linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1) 1;
  border-radius: 4px; /* Optional: if you want rounded corners */
  padding: 2px; /* Creates space between icon and border */
}

/* Additional print styles for better page control */

/* Add these non-print styles for better spacing */
.main_child {
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden; /* Prevents border issues */
}

.global_theme_ui_collapse {
  .el-collapse-item {
    margin-bottom: 10px;
  }
}
</style>
